module.exports = "//static.hsappstatic.net/conversations-embed/static-1.26123/sass/messagesWidgetShell.sass"